import { render, staticRenderFns } from "./user-management.vue?vue&type=template&id=74bee756&scoped=true"
import script from "./user-management.vue?vue&type=script&lang=js"
export * from "./user-management.vue?vue&type=script&lang=js"
import style0 from "./user-management.vue?vue&type=style&index=0&id=74bee756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bee756",
  null
  
)

export default component.exports